import React, { useState } from 'react'
import { Dialog } from '@material-ui/core'
import CircledPopUpFrame from '../Core/CircledPopUpFrame'
import { GetAQuoteForm } from './GetAQuoteForm'
import { ReactComponent as PersonCircle } from '../../assets/person_with_circle.svg'
import FlexView from 'react-flexview/lib'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import { isMobile, isBrowser } from 'react-device-detect'
import { TextButton } from '../Core/Buttons/TextButton'
import ViolationsService from '../../services/ViolationsService'
import { InsurancePurchaseContextStore } from '../../context/InsuracePurchaseContext'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
var classNames = require('classnames')

export const GetAQuotePopup = () => {
  const insurancePurchaseContext = React.useContext(
    InsurancePurchaseContextStore
  )
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const [open, setOpen] = useState(false)

  const openPopup = (e) => {
    e && e.stopPropagation && e.stopPropagation()

    let violations = ViolationsService.checkHullViolations(
      insurancePurchaseContext.selectedOption,
      insurancePurchaseContext.drones,
      insurancePurchaseContext.equipment
    )

    if (!ViolationsService.checkOperatorsViolations(offersContext.operators))
      return

    if (violations.can_buy_insurance) {
      setOpen(true)
    }
  }

  const close = (e) => {
    e && e.stopPropagation && e.stopPropagation()
    setOpen(false)
  }

  return (
    <>
      {isBrowser ? (
        <TextButton
          onClick={openPopup}
          text={'Email Quote'}
          startIcon={<MailOutlineIcon className="blue" />}
          withBorder={!isMobile}
          underline={isMobile}
          className={'quote-button-size'}
        />
      ) : (
        <FlexView onClick={openPopup}>
          <MailOutlineIcon className="blue" />
          <div
            className={classNames('blue text-small margin-left-3', {
              underline: isMobile,
            })}>
            Email Quote
          </div>
        </FlexView>
      )}
      <Dialog
        BackdropProps={{
          style: { backgroundColor: 'white', opacity: 0.64 },
        }}
        fullWidth
        onClick={(e) => e.stopPropagation()}
        open={open}
        onClose={close}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
        maxWidth={'xs'}>
        <CircledPopUpFrame onCancel={close}>
          <GetAQuoteForm close={close} />
        </CircledPopUpFrame>
      </Dialog>
    </>
  )
}
